package dev.krno.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import dev.krno.data.EventData
import dev.krno.rive.__krno
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun RegisterCta() {
    Section(attrs = { classes("wrap") }) {
        Div(attrs = {
            id("register")
            classes("cta")
        }) {
            H2 {
                Text("See you on")
                Br()
                Text(EventData.EVENT_DATE)
            }
            P {
                Text(
                    "Registration is free and takes a minute. We close it when the 40th seat is gone."
                )
            }
            A(href = EventData.REGISTER_URL, attrs = {
                classes("btn", "btn-fill", "btn-xl")
                target(ATarget.Blank)
                attr("rel", "noopener")
                // Luma opens a modal and preventDefaults; href/target are the no-JS fallback.
                attr("data-luma-action", "checkout")
                attr("data-luma-event-id", EventData.LUMA_EVENT_ID)
            }) {
                Text("Register for BrnKo")
                Span(attrs = { classes("ms") }) { Text("open_in_new") }
            }

            // Luma's script scanned the DOM before Compose mounted this anchor,
            // so ask it to bind the button now that it exists.
            DisposableEffect(Unit) {
                val cancel = __krno.initLumaCheckout()
                onDispose { cancel() }
            }
        }
    }
}
